import types from "./types";

const REQUEST_SIGNUP = state => {
  state.status = "fetching";
};

const SUCCESS_REQUEST_SIGNUP = state => {
  state.status = "success";
};

const FAILURE_REQUEST_SIGNUP = state => {
  state.status = "failure";
};

const REQUEST_UPDATE_USER = state => {
  state.statusUpdate = "fetching";
};

const SUCCESS_REQUEST_UPDATE_USER = (state, { body }) => {
  state.statusUpdate = "success";
  state.User = body;
};

const FAILURE_REQUEST_UPDATE_USER = state => {
  state.statusUpdate = "failure";
};


const REQUEST_USERS = state => {
  state.statusUsers = "fetching";
};

const SUCCESS_REQUEST_USERS = (state, {body}) => {
  state.Users = body;
  state.statusUsers = "success";
};

const FAILURE_REQUEST_USERS = state => {
  state.statusUsers = "failure";
};


const REQUEST_USER = state => {
  state.statusUser = "fetching";
};

const SUCCESS_REQUEST_USER = (state, {body}) => {
  state.User = body;
  state.statusUser = "success";
};

const FAILURE_REQUEST_USER = state => {
  state.statusUser = "failure";
};

const REQUEST_CREATE_USER = state => {
  state.statusCreate = "fetching";
};

const SUCCESS_REQUEST_CREATE_USER = (state, { body }) => {
  state.statusCreate = "success";
  state.User = body;
};

const FAILURE_REQUEST_CREATE_USER = (state, { body }) => {
  console.log("ERROR CREATE " + JSON.stringify(body))
  state.statusCreate = "failure";
  state.User = body;
};

const REQUEST_READ_USER = state => {
  state.statusReadUser = "fetching";
};

const SUCCESS_REQUEST_READ_USER = (state, {body}) => {
  state.ReadUser = body;
  state.statusReadUser = "success";
};

const FAILURE_REQUEST_READ_USER = state => {
  state.statusReadUser = "failure";
};

const REQUEST_GET_OBS_USER_DATA = state => {
  state.statusObsUserData = "fetching";
};

const SUCCESS_REQUEST_GET_OBS_USER_DATA = (state, {body}) => {
  state.obsUserData = body;
  state.statusObsUserData = "success";
};

const FAILURE_REQUEST_GET_OBS_USER_DATA = state => {
  state.statusObsUserData = "failure";
};

const SET_OBS_USER_DATA = (state, body) => {
  state.obsUserData = body;
  state.statusObsUserData = "success";
};


const REQUEST_UPDATE_OBS_SETTINGS = state => {
  state.statusUpdateObsSettings = "fetching";
};

const SUCCESS_REQUEST_UPDATE_OBS_SETTINGS = (state, { body }) => {
  state.statusUpdateObsSettings = "success";
};

const FAILURE_REQUEST_UPDATE_OBS_SETTINGS = (state, { body }) => {
  state.statusUpdateObsSettings = "failure";
};
// const SET_DATE = (state, value) => {
//   state.selectedDate = value;
// };

export default {
  REQUEST_READ_USER,
  SUCCESS_REQUEST_READ_USER,
  FAILURE_REQUEST_READ_USER,

  REQUEST_SIGNUP,
  SUCCESS_REQUEST_SIGNUP,
  FAILURE_REQUEST_SIGNUP,

  REQUEST_CREATE_USER,
  SUCCESS_REQUEST_CREATE_USER,
  FAILURE_REQUEST_CREATE_USER,

  REQUEST_UPDATE_USER,
  SUCCESS_REQUEST_UPDATE_USER,
  FAILURE_REQUEST_UPDATE_USER,

  SET_OBS_USER_DATA,

  REQUEST_UPDATE_OBS_SETTINGS,
  SUCCESS_REQUEST_UPDATE_OBS_SETTINGS,
  FAILURE_REQUEST_UPDATE_OBS_SETTINGS,

  [types.REQUEST_ACTIVATE_ACCOUNT]: state => {
    state.statusAccountActivation = "fetching";
  },
  [types.SUCCESS_REQUEST_ACTIVATE_ACCOUNT]: state => {
    state.statusAccountActivation = "success";
  },
  [types.FAILURE_REQUEST_ACTIVATE_ACCOUNT]: state => {
    state.statusAccountActivation = "failure";
  },
  [types.REQUEST_FORGOT_PASSWORD]: state => {
    state.statusForgotPassword = "fetching";
  },
  [types.SUCCESS_REQUEST_FORGOT_PASSWORD]: (state, resp) => {
    state.statusForgotPassword = "success";
  },
  [types.FAILURE_REQUEST_FORGOT_PASSWORD]: state => {
    state.statusForgotPassword = "failure";
  },
  [types.REQUEST_RESET_PASSWORD]: state => {
    state.statusResetPassword = "fetching";
  },
  [types.SUCCESS_REQUEST_RESET_PASSWORD]: (state, resp) => {
    state.statusResetPassword = "success";
  },
  [types.FAILURE_REQUEST_RESET_PASSWORD]: state => {
    state.statusResetPassword = "failure";
  },

  REQUEST_USERS,
  SUCCESS_REQUEST_USERS,
  FAILURE_REQUEST_USERS,

  REQUEST_USER,
  SUCCESS_REQUEST_USER,
  FAILURE_REQUEST_USER,

  REQUEST_GET_OBS_USER_DATA,
  SUCCESS_REQUEST_GET_OBS_USER_DATA,
  FAILURE_REQUEST_GET_OBS_USER_DATA,
};
